import { deletePursuitDoc } from "@/features/pursuit/api/apiPursuitDocs";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useDeletePursuitDoc(pursuit_id, searchType, proposalId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (docId) => deletePursuitDoc(pursuit_id, docId),
    onSuccess: () => {
      queryClient.invalidateQueries(["pursuit-docs", pursuit_id]);
      queryClient.invalidateQueries(["pursuit-docs", searchType, proposalId]);
      queryClient.removeQueries([
        "chatHistory",
        "pursuit-chat",
        searchType,
        proposalId,
      ]);
      queryClient.removeQueries([
        "chatHistory",
        "proposal",
        searchType,
        proposalId,
      ]);
    },
  });
}
